import { Badge, type MantineColor } from "@mantine/core"

export function StatusBadge({
  children,
  color = "gray",
}: {
  children: string
  color?: MantineColor
}) {
  return (
    <Badge color={color} variant="light">
      {children}
    </Badge>
  )
}
